"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@jsonforms/core");
const antd_1 = require("antd");
function Checkbox({ data, className, id, enabled, uischema, schema, path, handleChange, label, }) {
    const checked = !!data; // convert undefined to false
    const labelDescription = core_1.Helpers.createLabelDescriptionFrom(uischema, schema);
    const defaultLabel = labelDescription.show ? labelDescription.text : "";
    return ((0, jsx_runtime_1.jsx)(antd_1.Checkbox, { checked: checked, onChange: (e) => handleChange(path, e.target.checked), className: className, id: id, disabled: !enabled, children: label ?? defaultLabel }));
}
exports.Checkbox = Checkbox;
